import React, { useState } from "react";
import "jspdf-autotable";

export default function Workshop() {
    const [fameBlend, setFameBlend] = useState("<= 20%");


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Workshop </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Workshop</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
            <div className="container mt-4">
            {/* Warning Section */}
            <div className="alert alert-warning" role="alert">
                <h5>The report is not complete due to the following:</h5>
                <br />
                <strong>Period 1</strong>
                <br />
                ⚠ Particulate filter: No data found
            </div>

            {/* Fuel Grade Section */}
            <div className="card p-4">
                <h5>Enter fuel grade</h5>
                <p><strong>Sulphur content, ppm (Maximum value 10):</strong> 10</p>
                <p><strong>FAME blend:</strong></p>
                <div className="form-check">
                    <input
                        type="radio"
                        className="form-check-input"
                        id="fame20"
                        name="fameBlend"
                        value="<= 20%"
                        checked={fameBlend === "<= 20%"}
                        onChange={() => setFameBlend("<= 20%")} />
                    <label className="form-check-label" htmlFor="fame20">&lt;= 20%</label>
                </div>
                <div className="form-check">
                    <input
                        type="radio"
                        className="form-check-input"
                        id="fameAbove20"
                        name="fameBlend"
                        value="> 20%"
                        checked={fameBlend === "> 20%"}
                        onChange={() => setFameBlend("> 20%")} />
                    <label className="form-check-label" htmlFor="fameAbove20">&gt; 20%</label>
                </div>
                <div className="row">
                    <div className="col-md-3">
                    <button className="btn btn-primary mt-3">Update</button>
                    </div>
                </div>
            </div>

            {/* Maintenance Information */}
            <div className="mt-4">
                <p>
                    The maintenance intervals shown here in Operational Analysis Web must never be used to make periodic maintenance plans. 
                    Periodic plans must always be made based on the preface for the vehicle in question.
                </p>
                <p>
                    Calculated value is the longest permitted interval between two renewals of the component/part. 
                    Perform the renewal at the first interval (indicated in distance, operating time, or calendar time) that occurs after the previous renewal.
                </p>
                <p>
                    On condition that the vehicle is using Scania approved oils and that the vehicle continues to be used as during the analysis period, 
                    the component is to be renewed at the following intervals:
                </p>
            </div>
        </div>
                
            </div>

            
        </div>
    );
}
